import React from "react";
import SectionHeading from "./SectionHeading";
import { LANDING } from "@/constants/testIds";

const ROWS = [
  { label: "IC", value: "Process" },
  { label: "AML / KYC", value: "Discipline" },
  { label: "Custody", value: "Appropriate" },
  { label: "Reporting", value: "Disciplined" },
];

const Governance = () => {
  return (
    <section
      id="governance"
      data-testid={LANDING.governance}
      className="relative py-32 lg:py-44 border-t border-[var(--kr-line-soft)]"
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-6">
          <SectionHeading
            index="15"
            label="Institutional Governance"
            title={
              <>
                Governance is the{" "}
                <span className="italic text-[var(--kr-gold)]">
                  architecture
                </span>{" "}
                of trust.
              </>
            }
          />
          <p className="mt-8 text-[var(--kr-text-muted)] text-[17px] leading-[1.85] max-w-[58ch]">
            The platform is constructed on institutional foundations and is
            intended to be supported by independent administration, appropriate
            custody arrangements, a defined investment committee process and
            rigorous conflicts management, together with a culture of
            documented, repeatable underwriting. The platform is intended to
            engage where transparency is achievable — and decline where it is
            not.
          </p>
        </div>

        <div className="lg:col-span-6 lg:pl-10">
          <div className="border-t border-[var(--kr-line)]">
            {ROWS.map((r) => (
              <div
                key={r.label}
                className="flex items-baseline justify-between py-7 border-b border-[var(--kr-line)] group"
              >
                <span className="font-mono-label text-[11px] text-[var(--kr-text-muted)] group-hover:text-[var(--kr-gold)] transition-colors duration-300">
                  {r.label}
                </span>
                <span className="font-serif-display text-[1.5rem] text-[var(--kr-text)]">
                  {r.value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Governance;
